import React, { useRef } from "react";
import styles from "./DropMenu.module.css";
import { primaryBoxShadow } from "../../../Global.module.css";
import { useOutsideClick } from "../../../helpers/useOutsideClick";

export default function DropMenu({ children, position, onClose }) {
	const ref = useRef();

	useOutsideClick(ref, () => {
		if (onClose) onClose();
	});
	return (
		<div
			ref={ref}
			className={`${styles.dropMenu} ${styles[position]} ${primaryBoxShadow}`}
		>
			{children}
		</div>
	);
}
